import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Dashboard from '../../Dashboard'
import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import { selectUserData } from '../../../reducers/userDataReducer'

import './Instructions.scss'

const Instructions = ({ selectedBuilding, userData }) => {
  const { t } = useTranslation(['instructions'])
  const { buildingId: paramsBuildingId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (selectedBuilding && selectedBuilding.id) {
      if (paramsBuildingId !== String(selectedBuilding.id)) {
        navigate(`/dashboard/building-dashboard/instructions/${selectedBuilding.id}`)
      }
    }
  }, [selectedBuilding, paramsBuildingId, navigate])

  // Only show for building ID 638
  if (!selectedBuilding || selectedBuilding.id !== 638) {
    return (
      <Dashboard.Container className="ctp-instructions">
        <div className="instructions-header">
          <h1>{t('instructions:header')}</h1>
        </div>
        <div className="instructions-content">
          <p>{t('instructions:notAvailableMessage')}</p>
        </div>
      </Dashboard.Container>
    )
  }

  // Only show for PropertyManager and ShiftManager (Front Desk)
  const userRole = userData?.user?.role
  if (!['PropertyManager', 'ShiftManager'].includes(userRole)) {
    return (
      <Dashboard.Container className="ctp-instructions">
        <div className="instructions-header">
          <h1>{t('instructions:header')}</h1>
        </div>
        <div className="instructions-content">
          <p>{t('instructions:noAccessMessage')}</p>
        </div>
      </Dashboard.Container>
    )
  }

  const instructions = [
    {
      content:
        'PLEASE KEEP PACKAGES FOR THE FOLLOWING APT\nALL THE TOWNHOMES:TH1,TH2,TH3,TH4,TH5,TH6,TH7\n23A & 14F\n19B HOLD ALL PERISHABLE PACKAGES\nAll other units: packages will be delivered to the door by the carriers.\nIf a package is left at the front desk: Notify the resident about the package via text app and store it in the back package room, label it - Date it.\nCheck the names to make sure they are current residents!!',
      lastChangedBy: 'CRS CRS on 10/22/25',
    },
    {
      content:
        'The Valet parking is strictly for resident guests who are visiting the property. They are not for guests who want to use us for retail parking.',
      lastChangedBy: 'Lynn Guevara on 3/8/25',
    },
    {
      content:
        'Emergency Protocol for entrapment in the elevator:\n \nOtis Elevator Service number\n800-233-6847\nBuilding ID: TH552305\n  First of all Call Otis\nIf OTIS do not come or the person in the elevator needs medical assistance, CALL 911 immediately, then Notify Diego V. or the person on call\n \nElevator malfunction:\n \nCall OTIS , have Building ID ready and make the report to have a mechanic on site. OTIS line is 24/7',
      lastChangedBy: 'Bryan Donis on 12/17/24',
    },
    {
      content:
        'DO NOT ANSWER ANY LEASING QUESTIONS. IF THEY ASK FOR AVAILABILITY, SPECIALS, RATES, ETC. TRANSFER TO THE LEASING OFFICE. IF NO ONE IS AVAILABLE, PLEASE TAKE PHONE NUMBER, EMAIL, FIRST, AND LAST NAME AND EMAIL IT TO ARRIVEUPPERKIRBY@TRINITY-PM.COM',
      lastChangedBy: 'Bryan Donis on 11/24/24',
    },
    {
      content:
        'Clubroom Important rules: No moving furniture\nno loud music/noise\nResident and guest Must leave on time\nDo not accept guest car keys from valet\n30 ppl max\nread over the agreement for all rules',
      lastChangedBy: 'CRS CRS on 11/23/24',
    },
    {
      content:
        'Packages need to be kept at the desk for these units: 23A, 15H, 14E, 7E, 11F, 14F, 19H-17G, TOWNHOMES',
      lastChangedBy: 'CRS CRS on 11/4/24',
    },
    {
      content:
        'Food Delivery Allowed\n16K, 20K, 21A, 21B, 21C, 21D, 21E, 21F, 21J, 21K, 22B, 22C, 22H, 23B, 23C, 23G, 23H( no call needed for Sam), 23J, 24B, 24C, 24E, 24H, 24J, 24K ( dominos pizza only), PH1, PH3, PH4, PH5',
      lastChangedBy: 'CRS CRS on 11/4/24',
    },
    {
      content:
        'Reminder: Concierge turn on the music when you come in at 8am. Sonos or Youtube.\nRefill dog treats and bottled water.',
      lastChangedBy: 'CRS CRS on 11/1/24',
    },
    {
      content:
        'When the phone displays "NO SERVICE."\nClick MENU\n\nGo to SETTINGS\n\nBasic settings\n\nWi-Fi\n\nChoose the network and wait a few seconds; then the phone will be back in service.',
      lastChangedBy: 'CRS CRS on 10/19/24',
    },
    {
      content:
        'Concierge team:\nAll residents must be notified when visitors enter the lobby before sending anyone up please call. Verify if they are on the list, if not call. Always check.',
      lastChangedBy: 'Glenda Rubio on 9/11/24',
    },
    {
      content: 'CRS EMAIL TO USE\narriveupperkirby3333@gmail.com\nPw: Kirby3333!!',
      lastChangedBy: 'Quynh Do on 2/16/24',
    },
    {
      content:
        'The following items are considered emergencies Diego should be called:\n\nSmell of Gas\nNo A/C\nNo Water\nNo Electricity in the ENTIRE apartment\nToilet clogged in a 1Bedroom Apartment\nWater Leak\nSafety Device Malfunction\nPatio Door Breaks off the hinges\nFront Door Lock issues\nLocked out on the balcony',
      lastChangedBy: 'Larry Rogers on 8/27/23',
    },
    {
      content:
        "Please DO NOT Program the (Housekeeping - RESIDENT'S KEYS ) stored in the box FOR any other unit that is not the RESIDENT'S ONE.  (7E and 14K)  for example.",
      lastChangedBy: 'Bryan Donis on 5/27/22',
    },
    {
      content:
        'Concierge must check the pool every hour to make sure there are no parties or glass at the pool. Two guests per apartment. More guests must be approved by the manager. Pool closes at 11:00PM. Concierge must make sure that everyone exits the terrace by 11:00PM, no Exceptions',
      lastChangedBy: 'Bryan Donis on 5/12/22',
    },
    {
      content: 'Valet hours now from 7am-11pm Every day',
      lastChangedBy: 'Lynn Guevara on 5/5/22',
    },
    {
      content:
        'DO NOT ISSUE limited use key fobs to RESIDENTS without asking for a Valid ID CARD (with picture) and when retrieving the key from the system please do it under the name of the person on the ID. Unless Management says otherwise',
      lastChangedBy: 'Bryan Donis on 5/2/22',
    },
    {
      content:
        'MAKE SURE ALL DOCUMENTS / FORMS that require signature from a resident are signed up\nBEFORE handing them a car tag / key fob / temp tag or any item which involves a Request Form and a Office Fee.',
      lastChangedBy: 'Bryan Donis on 4/28/22',
    },
    {
      content:
        'When a reservation is submitted at the front desk, please e-mail agreement to resident and let them know they have to sign it up within 48 Hours or reservation will be cancelled.\n \nMAKE SURE YOU ADD THE NOTES ON BUILDING LINK RESERVATION LOG , as a private note. (Internal use)',
      lastChangedBy: 'Bryan Donis on 4/28/22',
    },
    {
      content:
        'ALL AMAZON , UPS , FEDEX packages/ deliveries have to be let up regardless of the instructions provided on the app to them as this is an automated instruction from the carriers, unless instruction is provided specifically by the resident.',
      lastChangedBy: 'Bryan Donis on 4/28/22',
    },
    {
      content: 'For MAINTENANCE EMERGENCIES check ON CALL SCHEDULE AT THE FRONT DESK',
      lastChangedBy: 'Bryan Donis on 4/6/22',
    },
    {
      content:
        'WHEN YOU ANSWER THE PHONE, THE GREETING SHOULD BE "THANK YOU FOR CALLING ARRIVE UPPER KIRBY, THIS IS "your name" at the Front Desk . HOW MAY I HELP YOU?"',
      lastChangedBy: 'Bryan Donis on 3/25/22',
    },
    {
      content:
        'If someone calls to set up a tour, please get first name, last name, email address, and phone number. I need this to create a guest card and log the tour in Entrata. Without this, this is how we get double booked',
      lastChangedBy: 'Coleman Ferguson on 3/7/22',
    },
    {
      content: 'WIFI PASSWORD:\n \nkirbyguest',
      lastChangedBy: 'Bryan Donis on 1/12/22',
    },
    {
      content:
        'Please make sure to take the hand-held phone with you when you step away from the Concierge Desk, so you will not miss any calls from prospects or residents.',
      lastChangedBy: 'Tammie Love on 1/4/22',
    },
    {
      content:
        "NEVER give any office employee's phone number to a resident. If after-hours contact with a staff member is required, please call the staff member and have them return the residents call. During office-hours, please transfer the call to the staff members office.",
      lastChangedBy: 'Tammie Love on 11/20/21',
    },
    {
      content:
        'Concierge- Any time a resident is causing a disturbance that you are not able to handle you are required to handle the situation by calling the manager. For example if residents are in the pool area after 11:00 pm and refuse to leave you are required to call the manager. It is your responsibility to resolve every situation.',
      lastChangedBy: 'Bryan Donis on 11/17/21',
    },
    {
      content:
        'We do not allow Airbnb VRBO or any subleasing of any kind. Contact manager if you suspect someone is subleasing.',
      lastChangedBy: 'Bryan Donis on 11/17/21',
    },
    {
      content:
        "Please never allow or walk guests upstairs if the resident do not answer the phone, even if they state that residents are expecting them, DO NOT GO UPSTAIRS TO KNOCK ON RESIDENT'S DOORS WITH A GUEST AS A COMPANION.",
      lastChangedBy: 'Bryan Donis on 11/17/21',
    },
    {
      content:
        "At 6:00 PM  LOCK the assistants' manager , Package room and the leasing office door as there are important Items in there, especially if the desk has to be let alone.",
      lastChangedBy: 'Bryan Donis on 11/9/21',
    },
    {
      content:
        'Always call to announce guests and food deliveries, Do not allow any guests upstairs if the resident do not authorize it.\n \nFood deliveries (if they do not answer , confirm name of the resident and send a text to let them know the food is here)',
      lastChangedBy: 'Bryan Donis on 11/4/21',
    },
    {
      content:
        'If a resident calls and states there are no available parking spaces in the garage please call the manager immediately so we can tow any unauthorized vehicles.',
      lastChangedBy: 'Melissa Crowell on 7/12/21',
    },
    {
      content:
        'IF you or a resident hears louds noise that may be fireworks or gunshots please contact HPD immediately and then call the manager',
      lastChangedBy: 'Melissa Crowell on 7/12/21',
    },
    {
      content:
        'Beware there is a package thief in Houston. She has stolen packages at several apartment buildings in town. If you leave the desk make sure the package room and leasing office are locked.',
      lastChangedBy: 'Melissa Crowell on 6/29/21',
    },
    {
      content: 'Please do not add, change, or delete bookmarks on google chrome.',
      lastChangedBy: 'Quayde Binder on 3/29/21',
    },
    {
      content: 'We do not loan our ladders, equipment, furniture, vacuums or etc to residents.',
      lastChangedBy: 'Melissa Crowell on 3/9/21',
    },
    {
      content:
        'DO NOT validate parking tickets from the retail garage. Approved vendors to validate: Core Landscape all others must have manager approval. We do not validate housekeepers, dog walkers, guests or etc.',
      lastChangedBy: 'Melissa Crowell on 2/1/21',
    },
    {
      content:
        'DO NOT block elevators for package deliveries. They can use with a key but do not put in independent mode for them.',
      lastChangedBy: 'Quayde Binder on 12/8/20',
    },
    {
      content: 'The new pool hours are 6AM-11:00pm.',
      lastChangedBy: 'Melissa Crowell on 9/11/20',
    },
    {
      content:
        "Just a reminder that we never share camera footage with a resident, guest or anyone. If someone is requesting camera footage tell them to contact the manager. Don't verbally review camera footage with anyone because it can be violation of privacy. If a police officer is requesting camera footage contact the manager immediately.",
      lastChangedBy: 'Melissa Crowell on 8/12/20',
    },
    {
      content:
        'Please include every issue and resident complaint/concerns in the shift log. It is very important that all information is reported in the shift log.',
      lastChangedBy: 'Melissa Crowell on 5/12/20',
    },
    {
      content: 'The number for Spartan Security on the office and retail side is 832-727-2569',
      lastChangedBy: 'Melissa Crowell on 4/8/20',
    },
    {
      content:
        'ALL packages must be delivered to the resident door by the carrier. Please advise carriers upon arrival and issue a vendor key, keep their DL or ID until they return the vendor key.',
      lastChangedBy: 'Melissa Crowell on 3/16/20',
    },
    {
      content:
        'Do not accept car keys from ANYONE. Concierge should never have a car key at the front desk.',
      lastChangedBy: 'Melissa Crowell on 2/17/20',
    },
    {
      content:
        'If a resident reports to you that an unauthorized vehicle is parked in their space contact the manager immediately for tow instructions and tow approval.',
      lastChangedBy: 'Melissa Crowell on 1/27/20',
    },
    {
      content:
        'DO NOT Allow anyone not even delivery persons into the package room. Only Employees are allowed to be in the package room.',
      lastChangedBy: 'Melissa Crowell on 1/10/20',
    },
    {
      content:
        'Residents are not permitted to allow guests vehicles in the parking garage. Concierge is not allowed to accept car keys from residents or guests. Once valet is closed guests must street park or park in the retail garage at their expense.',
      lastChangedBy: 'Melissa Crowell on 10/10/19',
    },
    {
      content:
        'Do not sign for furniture deliveries by furniture companies. All large shipped furniture that is delivered by UPS or USPS or FEDEX and etc must go directly to unit. We do not have storage space for these items. Resident must give permission to enter apartment for carrier to delivery. You must escort carrier to the unit and open the door. Do not sign for certified mail',
      lastChangedBy: 'Melissa Crowell on 8/30/19',
    },
  ]

  return (
    <Dashboard.Container className="ctp-instructions">
      <div className="instructions-header">
        <h1>{t('instructions:managementHeader')}</h1>
      </div>
      <div className="instructions-content">
        {instructions.map((instruction, index) => (
          <div key={index} className="instruction-card">
            <div className="instruction-text">
              {instruction.content.split('\n').map((line, lineIndex) => (
                <p key={lineIndex}>{line}</p>
              ))}
            </div>
            <div className="instruction-meta">
              <span className="last-changed">
                {t('instructions:lastChangedByPrefix', { name: instruction.lastChangedBy })}
              </span>
            </div>
          </div>
        ))}
      </div>
    </Dashboard.Container>
  )
}

export default connect((state) => ({
  selectedBuilding: selectActiveBuilding(state),
  userData: selectUserData(state),
}))(Instructions)
